export default function JsonLd({id, item}: {
    id: string,
    item: object,
}) {
    return <script
        id={id}
        type="application/ld+json"
        dangerouslySetInnerHTML={{__html: JSON.stringify(item)}}
    />;
}
